<template>
  <PageSecondary>
    <template #title>Аудит</template>
    Привет! Супер. Условия бесплатного аудита проекта:
    <ul style="">
      <li>Над проектом работают дольше 1000 часов.</li>
      <li>Проект работает как минимум в тестовом режиме.</li>
      <li>Проект не брошен, а в стадии активной работы.</li>
      <li>У проекта есть лидер.</li>
    </ul>
    Если условия выполнены - напиши мне <a href="https://t.me/alanverne" target="_blank">в Telegram</a> описание проекта и я уделю 3-12 часов для аудита, анализа и советов.
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
export default {
name: "WannaAudit",
  components: {PageSecondary}
}
</script>

<style scoped>

</style>
